document.addEventListener('DOMContentLoaded', function () {
  const container = document.getElementById('rs-attentive-footer');
  if (!container) return;

  const { workerUrl, sourceId, brand } = container.dataset;
  if (!workerUrl || !sourceId || !brand) return;

  const form       = container.querySelector('.attentive-footer__form');
  const input      = container.querySelector('.attentive-footer__input');
  const successEl  = container.querySelector('.attentive-footer__success');
  const errorEl    = container.querySelector('.attentive-footer__error');

  function show(el)  { if (el) el.style.display = 'block'; }
  function hide(el)  { if (el) el.style.display = 'none';  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    const email = input.value.trim();
    if (!email) return;

    fetch(workerUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, signUpSourceId: sourceId, brand })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('API error ' + res.status);
        return res.json();
      })
      .then(function () {
        show(successEl);
        hide(errorEl);
        input.value = '';
      })
      .catch(function (err) {
        console.error('[attentive-footer]', err.message);
        show(errorEl);
        hide(successEl);
      });
  });
});
